export function isValidGroup(group) {
  return Boolean(group && typeof group.name === 'string' && group.name.trim()
    && Array.isArray(group.meters) && group.meters.every((member) => (
    (typeof member === 'string' && member.trim())
      || (member && typeof member === 'object'
        && typeof (member.name ?? member.id) === 'string'
        && (member.name ?? member.id).trim()
        && (member.sign === undefined || member.sign === 1 || member.sign === -1))
  )));
}

export function resolveGroup(groups, routeId) {
  let name;
  try {
    name = decodeURIComponent(routeId);
  } catch {
    return undefined;
  }
  return Array.isArray(groups)
    ? groups.find((group) => isValidGroup(group) && group.name === name)
    : undefined;
}
